import { useContext } from 'react';
import UserContext from './context/UserContext';
import Authenticator from './components/authentication/Authenticator';
import PagesRenderer from './components/page_renderer/PagesRenderer';

function App() {
  const { isAuthorized, token } = useContext(UserContext);

  return (
    <Authenticator is_authorized={isAuthorized}>
      <PagesRenderer token={token} />
    </Authenticator>
  );
}

export default App;
